import type { PreviewDictionary } from './types';

export const en: PreviewDictionary = {
    bottomTabBar: {
        home: 'Home',
        map: 'Map',
        products: 'Products',
        carwash: 'Car wash',
        ageGated: 'Age gated',
        more: 'More',
    },
    home: {
        greeting: 'Hi,',
        myClubs: 'My Clubs',
        viewAll: 'View all',
        coupons: 'Coupons',
        inStore: 'In Store',
        mealDeals: 'Meal deals',
        mealDealsValidity: 'Valid between May 27th 2025 and November 10th 2025',
    },
    customizePanel: {
        title: 'Customize app preview',
        regionLabel: 'Region',
        regionQc: 'Québec',
        regionCa: 'Rest of Canada',
        languageLabel: 'Language',
        reorderSections: 'Reorder sections',
    },
    common: {
        languageEn: 'English',
        languageFr: 'French',
        emptyPlaceholder: 'No content yet...',
    },
    promotion: {
        title: 'Promotion',
        use: 'Use',
        upcoming: 'Upcoming',
        expired: 'Expired',
        validBetweenStart: 'Valid between ',
        validBetweenJoin: ' and ',
        timeRangeJoin: ' to ',
        validUntil: 'Valid until:',
    },
    games: {
        header: 'Games & Contests',
        playButton: 'Play',
        fromDateStart: 'From ',
        fromDateJoin: ' to ',
    },
    promotions: {
        title: 'Promotions',
        tabCoupons: 'Coupons',
        tabInStore: 'In Store',
        couponsHeading: 'COUPONS',
        inStoreHeading: 'IN STORE',
        offersPlaceholder: 'Offers',
        categoriesPlaceholder: 'Categories',
    },
};
